const shadows: Record<string | number, string> = {
  knob: "1px 2px 6px rgba(68, 68, 68, 0.25)",
  card: "1px 2px 6px rgba(68, 68, 68, 0.25)",
  banner: "1px 2px 12px rgba(68, 68, 68, 0.25)",
  navbar: "0px 4px 4px rgba(68, 68, 68, 0.15)",
  prominent: "7px 8px 24px rgba(68, 68, 68, 0.25)",
};

shadows[0] = shadows.card;

export default shadows;
